import { render } from "./SettingsOAuthRedirect.vue?vue&type=template&id=944e4cd8&ts=true"
import script from "./SettingsOAuthRedirect.vue?vue&type=script&lang=ts"
export * from "./SettingsOAuthRedirect.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__